import { ref } from "vue";
import Swal from "sweetalert2";
import i18n from "@/i18n/index";

import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import router from "@/router/index";
import {
  permissions,
  userPermissions,
  clubUUID,
  userUUID,
} from "@/shared/state";
import {
  Permission,
  PermissionResponse,
  PermissionRequest,
  AffectedPermissionRequest,
} from "@/interfaces/permission";

const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function usePermission() {
  const error = ref<string | null>(null);
  const isRequestPermission = ref<boolean | false>(false);
  const getPermissions = async () => {
    try {
      isRequestPermission.value = true;
      const response = await authenticatedFetch(
        `${API_URL}permissions`,
        {
          method: "GET",
        },
        false,
        "",
        false,
      );
      permissions.data = response?.data || [];
      isRequestPermission.value = false;
    } catch (err: any) {
      error.value = err.message;
      isRequestPermission.value = false;
    }
  };
  const getUserPermissions = async (body: any) => {
    try {
      isRequestPermission.value = true;
      userPermissions.data = [];
      const response = await authenticatedFetch(
        `${API_URL}user-permissions/${body.userUUID}/${body.clubUUID}`,
        {
          method: "GET",
        },
        false,
        "",
        false,
      );

      if (response?.data) {
        userPermissions.data = response?.data || [];
        isRequestPermission.value = false;
        return true;
      } else {
        isRequestPermission.value = false;
        return false;
      }
    } catch (err: any) {
      error.value = err.message;
      isRequestPermission.value = false;
    }
  };

  const addPermissions = async (body: PermissionRequest) => {
    try {
      isRequestPermission.value = true;
      const response = await authenticatedFetch(
        `${API_URL}permissions/store`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );

      isRequestPermission.value = false;
    } catch (err: any) {
      error.value = err.message;
      isRequestPermission.value = false;
    }
  };

  const affectedPermissionsToUser = async (body: AffectedPermissionRequest) => {
    try {
      isRequestPermission.value = true;
      const response = await authenticatedFetch(
        `${API_URL}permissions/affected`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response) {
        if (response?.data) {
          isRequestPermission.value = false;
          return true;
        }
        isRequestPermission.value = false;
        return false;
      }
    } catch (err: any) {
      error.value = err.message;
      isRequestPermission.value = false;
    }
  };

  const deletePermission = async (id: number) => {
    try {
      isRequestPermission.value = true;
      const response = await authenticatedFetch(
        `${API_URL}permissions/delete/${id}/${userUUID.value}`,
        {
          method: "DELETE",
        },
        true,
        "",
        true,
      );
      const index = permissions?.data?.findIndex(
        (permissions) => permissions?.id === id,
      );
      if (index !== -1) {
        permissions.data.splice(index, 1);
      }
      isRequestPermission.value = false;
    } catch (err: any) {
      error.value = err.message;
      isRequestPermission.value = false;
    }
  };

  const hasPermission = (permissionName: string) => {
    if (!userPermissions?.data) return false;

    // Object.values kat-akhod les arrays dyal kol groups, w .flat() kat-jma3hom f array wa7da kbira
    const allPermissions = Object.values(userPermissions.data).flat();

    // Daba t9dr t-dir .find() 3la l-permissions kamlin f da9qa wa7da
    const permission = allPermissions.find((p) => p.name === permissionName);

    return permission ? permission.status : false;
  };

  return {
    getPermissions,
    getUserPermissions,
    affectedPermissionsToUser,
    addPermissions,
    hasPermission,
    deletePermission,
    isRequestPermission,
  };
}
